import { QueryFunctionContext, useQueries } from "@tanstack/react-query";
import { DetectionParams } from "../services/TaglessApi/TaglessApiService";
import { Device } from "../types/Device";
import { useApiClient } from "../providers/ApiClientProvider";
import { Detection } from "../types/Detection";
import { createUrlWithQuery } from "./utils";

interface DetectionResp {
    data: {
        counts: Detection[];
    };
}
export const useFetchRawCounts = (
    devices: Device[],
    detectionParam: DetectionParams,
    deploymentId: string | undefined,
) => {
    const apiClient = useApiClient();
    const results = useQueries({
        queries: devices.map((device) => ({
            queryKey: ["raw-counts", device.id],
            queryFn: async ({ signal }: QueryFunctionContext) => {
                const response = await apiClient.get<DetectionResp>(
                    createUrlWithQuery(`/devices/${device.id}/counts`, {
                        ...detectionParam,
                    }),
                    { signal },
                );
                return response.data;
            },
            enabled: !!deploymentId && !!device.id,
        })),
        combine: (results) => {
            return {
                data: results.map((result) => result.data?.counts || []),
                isPending: results.some((result) => result.isPending),
                isFetching: results.some((result) => result.isFetching),
                error: results.find((result) => result.error)?.error,
                isError: results.some((result) => result.isError),
            };
        },
    });
    return results;
};
